<template xmlns="http://www.w3.org/1999/html">
  <loader-content :ref="(el: any) => loader = el">
  <div class="d-flex flex-column email-login" v-if="!state.emailIsSent">
    <div class="text-center">
      <h1>{{ $t('reset_password')}}</h1>
    </div>
    <div class="text-center">
      <span class="info">{{$t('enter_email_to_reset_password')}}</span>
    </div>
    <div class="d-flex flex-column gap-sm">
      <div class="">
        <label for="email" class="form-label text-capitalize-first">{{ $t('email') }}</label>
        <input v-model="state.email" id="email" type="email" class="form-control" :placeholder="$t('enter_email')">
      </div>
    </div>
    <div>
      <button @click.prevent="send()" class="btn btn-primary w-100 btn-lg">{{$t('send_reset_email')}}</button>
    </div>
  </div>
  <div v-else class="d-flex flex-column email-login">
    <div class="text-center">
      <h1>{{ $t('check_your_email')}}</h1>
    </div>
    <div class="text-center d-flex justify-content-center">
      <div class="mail-icon">
        <SvgIcon icon="mail"></SvgIcon>
      </div>
    </div>
    <div class="text-center">
      <span class="info">{{$t('password_reset_email_sent')}}</span>
    </div>
  </div>
  </loader-content>
</template>
<script lang="ts" setup>
import {reactive} from "@vue/reactivity";
import {api} from "@/service/APIClient";
import { ref} from "vue";
import {useStore} from "vuex";
import {useNotification} from "@kyvg/vue3-notification";
import {$t} from "@/i18n";
import SvgIcon from "@/components/SvgIcon.vue";
import LoaderContent from "@/components/LoaderContent.vue";

const state = reactive({
  email: '' as string,
  emailIsSent: false as boolean
});

const loader = ref<InstanceType<typeof LoaderContent> | null>(null)
const store = useStore()
const notification = useNotification()

const send = async () => {
  loader.value?.load(async () => {
    try {
      await api.call.token.resetPassword(state.email)
    } catch (e) {}
    state.emailIsSent = true
  })
}

</script>
